import React, { useEffect } from 'react';
import { Table } from 'react-bootstrap';
import { createUseStyles } from 'react-jss';
import RowValidacionRequisitos from './RowValidacionRequisitos';
const TablaValidacionRequisitos = ({ requisitos, requisitosValidadosFc }) => {
  const [requisitosValidados, setRequisitosValidados] = React.useState();
  useEffect(() => {
    const arrayDeRequisitos = [];
    requisitos.forEach((requisito) => {
      arrayDeRequisitos.push({
        idRequisitoPuesto: requisito.idRequisitoPuesto,
        validado: requisito.presentoDocumentacion,
      });
    });
    setRequisitosValidados(arrayDeRequisitos);
  }, [requisitos]);
  const classes = createUseStyles({
    scrollable: {
      overflow: 'scroll',
      height: '500px',
    },
  })();
  const handleAgregar = (idRequisitoPuesto, validado) => {
    setRequisitosValidados((prevRequisitos) =>
      prevRequisitos?.map((v) =>
        v.idRequisitoPuesto === idRequisitoPuesto ? { ...v, validado } : v,
      ),
    );
    requisitosValidadosFc?.(requisitosValidados);
  };
  return (
    <div className="container-fluid">
      <div className={classes.scrollable}>
        <Table bordered hover size="sm">
          <thead>
            <tr>
              <th className="text-center align-middle"> Validar </th>
              <th className="text-center align-middle">Nombre</th>
              <th className="text-center align-middle">Descripción</th>
              <th className="text-center align-middle">Requerido</th>
              {/* <th className="text-center align-middle">Excluyente</th> */}
            </tr>
          </thead>
          <tbody>
            {requisitos.map((requisito) => {
              return (
                <RowValidacionRequisitos
                  key={requisito.id} // Add the key prop here
                  requisito={requisito}
                  requisitoValidado={(id, valid) => {
                    handleAgregar(id, valid);
                  }}
                />
              );
            })}
          </tbody>
        </Table>
      </div>
    </div>
  );
};
export default TablaValidacionRequisitos;
